module.exports = __webpack_public_path__ + "img/default_document_icon@2x.845bf3ba.png";